module.exports = __webpack_public_path__ + "img/9.e704cf52.jpg";